import { LogoMark } from "@/components/Header";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-navy text-white/70">
      <div className="mx-auto max-w-7xl px-6 py-14 md:px-12">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="flex items-center gap-3">
            <LogoMark className="h-9 w-9" />
            <div>
              <p className="font-display text-lg font-bold text-white">
                Autismo <span className="text-flame">+</span> Cuidados
              </p>
              <p className="text-sm">Guia educativo em formato digital.</p>
            </div>
          </div>
          <p className="text-sm">© 2026 • Todos os direitos reservados</p>
        </div>
        <p className="mt-10 max-w-3xl border-t border-white/10 pt-8 text-xs leading-relaxed text-white/50">
          Material educativo. Não substitui avaliação, diagnóstico, tratamento ou
          orientação individualizada de profissionais de saúde, educação ou direito.
          As estratégias descritas devem ser adaptadas às necessidades de cada pessoa.
        </p>
      </div>
    </footer>
  );
}
